import { Button } from "@devhop/ui";
import { PlusIcon } from "lucide-react";

type DepartmentsToolbarProps = {
  canManage: boolean;
  onCreate: () => void;
};

export function DepartmentsToolbar({
  canManage,
  onCreate,
}: DepartmentsToolbarProps) {
  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div>
          <h2 className="font-bold text-2xl tracking-tight">ພະແນກ</h2>
          <p className="text-muted-foreground">ຈັດການພະແນກໃນອົງກອນ (ກຸ່ມໃຫຍ່).</p>
        </div>
        {canManage && (
          <div className="flex items-center space-x-2">
            <Button onClick={onCreate}>
              <PlusIcon className="h-4 w-4" />
              ສ້າງພະແນກ
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
